import {
    config,
    requestOptions,
    requestTypes,
    sendRequest,
} from "../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************

class ServerSiteApi{

      static getEnvironment() {

        return sendRequest(
            requestOptions(config.URL + `sites/environment`,
                requestTypes.GET,
            ),
        );
      }

      static getOwnQuotaWindow() {
        return sendRequest(
            requestOptions(config.URL + `sites/own-quota-window`,
                requestTypes.GET,
            ),
        );
      }

}

export const siteApi = config.environment.MODE === config.modes.SERVER ? ServerSiteApi : ServerSiteApi;